import angular from 'angular';
import tableGridRadioCellComponent from './tableGridRadioCell.component';

let tableGridRadioCellModule = angular.module('tableGridRadioCell', []).directive('tableGridRadioCell', tableGridRadioCellComponent);

export default tableGridRadioCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridRadioCell/tableGridRadioCell.js